import { render, staticRenderFns } from "./LaravelPagination.vue?vue&type=template&id=1fbe14d1&scoped=true&"
import script from "./LaravelPagination.vue?vue&type=script&lang=js&"
export * from "./LaravelPagination.vue?vue&type=script&lang=js&"
import style0 from "./LaravelPagination.vue?vue&type=style&index=0&id=1fbe14d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe14d1",
  null
  
)

export default component.exports